// extracted by mini-css-extract-plugin
export var asterisk = "MultipleCheckbox-module--asterisk--26a1e";
export var checkbox = "MultipleCheckbox-module--checkbox--2fd25";
export var checkboxClass = "MultipleCheckbox-module--checkboxClass--6eabe";
export var checked = "MultipleCheckbox-module--checked--00849";
export var labelCheckboxClass = "MultipleCheckbox-module--labelCheckboxClass--fa428";